import React, { useEffect, useState } from 'react';
import { Card, Col, FormInstance, Row, Select } from 'antd';
import { useQuery } from '@apollo/client';
import { queries } from '../../../graphql/graphql';
import { Loader } from '../../UI/Loader';
import { IPlanOwner } from '../../../types/planOwner';

export const SelectPlanOwner = ({
  form,
  onChange,
}: {
  form: FormInstance;
  onChange?: (value: string) => void;
}) => {
  const [planOwner, setPlanOwner] = useState<IPlanOwner | null>(null);
  const { data: planOwners, loading } = useQuery(queries.planOwners.PLAN_OWNERS);
  const value = form.getFieldValue('planOwnerId');

  useEffect(() => {
    if (planOwners?.planOwners && value) {
      setPlanOwner(planOwners.planOwners.find((c: IPlanOwner) => c.id === value));
    }
  }, [planOwners, value]);

  const planOwnerOptions = planOwners?.planOwners.map((planOwner: IPlanOwner) => ({
    label: planOwner.name,
    value: planOwner.id,
  }));

  const handleChange = (value: string) => {
    if (planOwners?.planOwners) {
      setPlanOwner(planOwners.planOwners.find((c: IPlanOwner) => c.id === value));
    }
    onChange?.(value);
  };

  if (loading) return <Loader />;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Select options={planOwnerOptions} value={value} onChange={handleChange} />
      </Col>
      {planOwner && (
        <Col span={24}>
          <Card>
            <Card.Meta title={planOwner.name} description={planOwner.ceo} />
          </Card>
        </Col>
      )}
    </Row>
  );
};
